var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    clipPath: "url(#clip0_15093_317467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.1665 12.5013H3.33317C2.89114 12.5013 2.46722 12.3257 2.15466 12.0131C1.8421 11.7006 1.6665 11.2767 1.6665 10.8346V3.33464C1.6665 2.89261 1.8421 2.46868 2.15466 2.15612C2.46722 1.84356 2.89114 1.66797 3.33317 1.66797H10.8332C11.2752 1.66797 11.6991 1.84356 12.0117 2.15612C12.3242 2.46868 12.4998 2.89261 12.4998 3.33464V4.16797M9.1665 7.5013H16.6665C17.587 7.5013 18.3332 8.24749 18.3332 9.16797V16.668C18.3332 17.5884 17.587 18.3346 16.6665 18.3346H9.1665C8.24603 18.3346 7.49984 17.5884 7.49984 16.668V9.16797C7.49984 8.24749 8.24603 7.5013 9.1665 7.5013Z",
    stroke: "#475467",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15093_317467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.143e8d0177199a395c9427b6735217f1.svg";
export { ForwardRef as ReactComponent };